import {setABToStorage} from '../storage';

const setABAndPostToParent = () => {
  const abNumber = setABToStorage();

  window.parent.postMessage(
    {
      data: {
        abNumber
      },
      scope: 'mol-fe-xpmodule-news-search-ab'
    },
    '*'
  );
};

const NOTIFICATION_KEY_PROMPT = 'mol-fe-browser-notifications-last-prompt-epoch';
const NOTIFICATION_KEY_SUBSCRIPTION = 'MOL-FE-WEB-PUSH_SUBSCRIPTION_STATUS';

const sendNotificationStatus = () => {
  let status = 'unsupported';

  if ('localStorage' in window) {
    try {
      status = 'none';

      if (window.localStorage.getItem(NOTIFICATION_KEY_PROMPT)) {
        status = 'prompted';
      }

      if (window.localStorage.getItem(NOTIFICATION_KEY_SUBSCRIPTION)) {
        status = 'subscribed';
      }
    } catch (error) {
      status = 'error';
    }
  }

  window.parent.postMessage(
    {
      data: {
        status
      },
      scope: 'newzit-notification-status'
    },
    '*'
  );
};

if (location.search && location.search.match(/command=notificationStatus/)) {
  sendNotificationStatus();
} else {
  setABAndPostToParent();
}
